export default __webpack_public_path__ + "static/media/bicep.201aac90.svg";